import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 一键退款接口
export const oneClickRefund = (data: any) => request({
  url: '/manage/one-click-refund',
  method: 'post',
  data
})

// 退款订单导出
export const orderExport = (data: any) => request({
  url: '/manage/refund-order-export' + objToUrlParams(data),
  method: 'post'
})

// 批量退款
export const setBatchRefund = (data: any) =>
  request({
    url: '/manage/deposit-order-batch-refund',
    method: 'post',
    data
  })